module.exports = __webpack_public_path__ + "img/icon_popup_playlist_add_2.e4e06bdd.svg";